import { c as _c } from "react/compiler-runtime";
import { useLocation } from 'react-router-dom';
import usePDPLayoutRevampTestVariant, { PDP_LAYOUT_REVAMP_VARIANTS } from './usePDPLayoutRevampTestVariant';
const VARIANTS_WITH_REVAMP_LAYOUT = [PDP_LAYOUT_REVAMP_VARIANTS.TEST_A, PDP_LAYOUT_REVAMP_VARIANTS.TEST_B];

// `?layoutRevamp=1` forces the new layout on any environment so design and QA
// can review it without waiting on a bucket assignment. `?layoutRevamp=0`
// forces the control back for the same reason.
const readPreviewOverride = search => {
  const value = new URLSearchParams(search).get('layoutRevamp');
  if (value === '1') {
    return true;
  }
  if (value === '0') {
    return false;
  }
  return null;
};
const useIsLayoutRevampVariant = t0 => {
  const $ = _c(4);
  const isEligible = t0 === undefined ? true : t0;
  const {
    search
  } = useLocation();
  const variant = usePDPLayoutRevampTestVariant(isEligible);
  if (!isEligible) {
    return false;
  }
  let t1;
  if ($[0] !== search) {
    t1 = readPreviewOverride(search);
    $[0] = search;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const previewOverride = t1;
  if (previewOverride !== null) {
    return previewOverride;
  }
  let t2;
  if ($[2] !== variant) {
    t2 = VARIANTS_WITH_REVAMP_LAYOUT.includes(variant);
    $[2] = variant;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default useIsLayoutRevampVariant;